import React from "react";
import "./styles.scss";

const Index = (props) => (
  <div key={props.key} className={`offer-type-tag-wrp ${props.type}`}>
    <div className={"ottw__text"}>{props.text}</div>
  </div>
);

Index.propTypes = {};

Index.defaultProps = {};

export default Index;
